import { useMemo, Fragment } from 'react';
import { ChevronIcon } from '@ui/kit/icons';
import { sequenceTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { useTaskContext, TaskContext } from '../../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../../hook.task-breakpoints.js';
import { SequenceInput } from '../input.content.js';
import { orderInputs } from '../util.order-inputs.js';
import { MobileVerticalFacitContainer } from './container.facit.mobile.js';
import { root, wrapper, label, container, chevron } from './container.facit.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function VerticalFacitContainer(props) {
  const context = useTaskContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sequenceTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  if (isMobile) {
    return /*#__PURE__*/jsx(MobileVerticalFacitContainer, {
      ...props
    });
  }
  return /*#__PURE__*/jsxs("div", {
    className: root,
    children: [/*#__PURE__*/jsxs("div", {
      className: wrapper,
      "data-theme": "input",
      children: [context === "facit" && /*#__PURE__*/jsx("p", {
        className: label,
        children: "Dit svar"
      }), /*#__PURE__*/jsx("div", {
        className: container,
        children: userOrderedInputs.map(input => /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(SequenceInput, {
            node: input,
            taskEntryKey: props.taskEntryKey
          }), /*#__PURE__*/jsx(ChevronIcon, {
            className: chevron,
            height: 8,
            strokeWidth: 3
          })]
        }, input.id))
      })]
    }), context === "facit" && /*#__PURE__*/jsxs("div", {
      className: wrapper,
      "data-theme": "facit",
      children: [/*#__PURE__*/jsx("p", {
        className: label,
        children: "Rigtigt svar"
      }), /*#__PURE__*/jsx("div", {
        className: container,
        children: /*#__PURE__*/jsx(TaskContext.Provider, {
          value: "readonly",
          children: props.task.content.map(input => /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(SequenceInput, {
              node: input,
              taskEntryKey: props.taskEntryKey
            }), /*#__PURE__*/jsx(ChevronIcon, {
              className: chevron,
              height: 8,
              strokeWidth: 3
            })]
          }, input.id))
        })
      })]
    })]
  });
}

export { VerticalFacitContainer };
//# sourceMappingURL=container.facit.js.map
